<template>
	<div class="index-login p-b-70 propay">
		<!-- 初始空白 -->
		<div v-if="loading"></div>
		<!-- 授权加载 -->
		<div v-else>
			<div class="main" :style="'background:'+ colorList[0]">
				<img :src="baseUrl+ imagesList[0]" />
				<div class="cbtn" @click="submitForm(0)" :style="'background:'+ colorList[2]">
					<div class="text">立即点击报名</div>
				</div>

				<img :src="baseUrl+item" v-for="(item, index) in imagesList" :key="index" v-if="index > 0" />
			</div>
			<div class="footer">
				<div class="price">{{ produInfo.productPrice }}</div>
				<div class="text" @click="submitForm(1)">
					<div class="breathe">立即报名</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { clickThrottle } from '@/utils/index'
	export default {
		data () {
			return {
				baseUrl:`${this.$siteURL}/imgs/mini/`,
				colorList:[],
				customerId:'',
				imagesList:[],
				loading:true,
				orderId:'',
				pathId:'',//投放平台pathid
				productId:1,
				produInfo:{}
				
			}
		},
		created(){
			this.productId = this.$route.query.productId || 1   //产品ID
			this.feedBack()
			this.getProduct()
		},
		methods:{
			async feedBack(){
				let data = await this.pathBack(window.location.href)
				this.customerId = data.customerId || ''
				this.pathId = data.pathId
				this.$store.commit("SET_PATHID", data.pathId)
			},
      		getProduct(){
				axios({
					method:'GET',
					url: `${this.$baseURL}/queryProductInfo`,
					params:{
						productId: this.productId
					}
				}).then(res => {
					this.loading = false
					this.produInfo = res.data
					this.imagesList = res.data.images
					this.colorList = res.data.theme && res.data.theme.indexOf(',') > 0 ? res.data.theme.split(',') : ['#fff','#1ACE9A','#1ACE9A']
				})
			},
			submitForm(val) {
				if(!clickThrottle(2000)) return
				this.commonPoint(this.pathId,this.productId,'ecApplyNow',val)
				axios({
					method:'POST',
					url: `${this.$baseURL}/userOrders`,
					params:{
						customerId:this.customerId,
						pathId:this.pathId,
						productId: this.productId,
						userPhone:''
					}
				}).then(res => {
					this.$router.push({
						path:'/product/question',
						query: {
							orderId: res.data.data.code,
							productId: this.productId,
							pathId: this.pathId,
							type:'cust'
						}
					})
				})
			},
		}
	}
</script>


<style scoped>
	.footer{background-image: url('./../../assets/images/btn2.png');}
	.price{color: #ff4242;position: absolute;left: 20px;bottom: 8px;font-size: 42px;font-weight: bold;}
	.cbtn{margin: 20px 30px 0px;padding: 18px 25px;background: #1ACE9A;text-align: center;border-radius: 35px;margin-bottom: 20px;}
	.cbtn .text{animation: testAnimation 1.5s linear infinite;color: #fff;font-size: 1.5rem;letter-spacing: 2px;font-weight: bold;cursor: pointer;}
	/* css3 */
	@keyframes testAnimation {
		0%{
			transform: scale(.9);
		}
		50%{
			transform: scale(1.2);
		}
		100%{
			transform: scale(.9);
		}
	}

	@media screen and (min-width:740px){
		.price{font-size: 90px;bottom:15px;}
	}
</style>



// WEBPACK FOOTER //
// src/views/product/custQues.vue